import { ChangeEvent, useCallback } from 'react';
import { PropsWithClassName } from 'src/shared/utils/types/PropsWithClassName';

import { cn } from '@shared/utils/helpers';

export type CheckboxInputProps = PropsWithClassName<{
  id?: string;
  name?: string;
  required?: boolean;
  error?: string;
  value?: boolean | null;
  onChange?: (value: boolean) => void;
}>;

export function CheckboxInput({ name, id, required, error, value, onChange, className }: CheckboxInputProps) {
  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      onChange?.(event.target.checked);
    },
    [onChange]
  );

  return (
    <input
      type="checkbox"
      name={name}
      id={id}
      className={cn(
        'px-3 py-2 border rounded outline-none',
        'disabled:bg-white',
        'focus:border-indigo-500',
        { 'border-red-500': error },
        className
      )}
      required={required}
      checked={value || false}
      onChange={handleChange}
    />
  );
}
